import React from 'react';
import { createRoot } from 'react-dom/profiling';
// import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/_layouts/Layout/Layout';
import AccountLayout from './components/_view/Account/AccountLayout/AccountLayout';
import useAuth, { AuthenticationProvider } from './hooks/useAuth';
import AdministratorLayout from './components/_view/Administrator/AdministratorLayout/AdministratorLayout';
import NotFound from './components/_view/Common/NotFound/NotFound';
import UserLayout from './components/_view/User/UserLayout/UserLayout';
import SupportLayout from './components/_view/Support/SupportLayout/SupportLayout';
import HelpLayout from './components/_view/Help/HelpLayout/HelpLayout';
import { AwsRum } from 'aws-rum-web';

try {
  const config = {
    sessionSampleRate: 1,
    identityPoolId: 'eu-west-1:04d62a01-2612-425e-b2ff-37d41c5517b7',
    endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
    telemetries: ['performance', 'errors', 'http'],
    allowCookies: true,
    enableXRay: false,
    signing: true, // If you have a public resource policy and wish to send unsigned requests please set this to false
  };

  const APPLICATION_ID = '7075694f-08a4-4a9f-91ec-c2c5db867708';
  const APPLICATION_VERSION = '1.0.0';
  const APPLICATION_REGION = 'eu-west-1';

  const awsRum = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
} catch {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

function RootRedirect() {
  const auth = useAuth();
  if (auth.isAuthenticationComplete) {
    if (auth.isSignedIn) {
      if (auth.groups.includes('administrators') || auth.groups.includes('organisationNonContributors')) {
        return <Navigate replace to="/administrator" />;
      }
      if (auth.groups.includes('users')) {
        return <Navigate replace to="/user" />;
      }
    }
    return <Navigate replace to="/account/signIn" />;
  }
  return <Navigate replace to="/404" />;
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  // <React.StrictMode>
  <AuthenticationProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<RootRedirect />} />
          <Route path="/account/*" element={<AccountLayout />} />
          <Route path="/administrator/*" element={<AdministratorLayout />} />
          <Route path="/user/*" element={<UserLayout />} />
          <Route path="/support/*" element={<SupportLayout />} />
          <Route path="/help/*" element={<HelpLayout />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </AuthenticationProvider>,
  // </React.StrictMode>,
);
